/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { businessMemoriesList } from "../funcs/businessMemoriesList.js";
import { businessMemoriesListContentScopes } from "../funcs/businessMemoriesListContentScopes.js";
import { businessMemoriesSearch } from "../funcs/businessMemoriesSearch.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListBusinessMemoryContentScopesResponseBody } from "../models/components/listbusinessmemorycontentscopesresponsebody.js";
import { SearchBusinessMemoriesResponseBody } from "../models/components/searchbusinessmemoriesresponsebody.js";
import {
  ListBusinessMemoriesRequest,
  ListBusinessMemoriesResponse,
  ListBusinessMemoriesSecurity,
} from "../models/operations/listbusinessmemories.js";
import {
  ListBusinessMemoryContentScopesRequest,
  ListBusinessMemoryContentScopesSecurity,
} from "../models/operations/listbusinessmemorycontentscopes.js";
import {
  SearchBusinessMemoriesRequest,
  SearchBusinessMemoriesSecurity,
} from "../models/operations/searchbusinessmemories.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class BusinessMemories extends ClientSDK {
  /**
   * listBusinessMemoryContentScopes businessMemories
   *
   * @remarks
   * List the complete content-scope tree and distinct-memory counts for the active project. Requires organization admin.
   */
  async listContentScopes(
    request?: ListBusinessMemoryContentScopesRequest | undefined,
    security?: ListBusinessMemoryContentScopesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListBusinessMemoryContentScopesResponseBody> {
    return unwrapAsync(businessMemoriesListContentScopes(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listBusinessMemories businessMemories
   *
   * @remarks
   * List memories extracted for the active project. Requires organization admin.
   */
  async list(
    request?: ListBusinessMemoriesRequest | undefined,
    security?: ListBusinessMemoriesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PageIterator<ListBusinessMemoriesResponse, { cursor: string }>> {
    return unwrapResultIterator(businessMemoriesList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * searchBusinessMemories businessMemories
   *
   * @remarks
   * Run semantic search over active memories in the active project. Requires organization admin.
   */
  async search(
    request: SearchBusinessMemoriesRequest,
    security?: SearchBusinessMemoriesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SearchBusinessMemoriesResponseBody> {
    return unwrapAsync(businessMemoriesSearch(
      this,
      request,
      security,
      options,
    ));
  }
}
